export default __webpack_public_path__ + "static/media/rnd-card2-1.cc119ae7.png";